module.exports = function getResource(label, vars = []) {
    const resources = {
        canApply: `You can now apply *${vars[0]} points* to your purchase for`,
        canApplyUpTo: `You can now apply up to *${vars[0]} points* for`,
        missingPointsClose: `You are *${vars[0]} point${vars[0] !== 1 ? 's' : ''}* away from *${vars[1]} off*.`,
        onceYouEarn: `Once you earn *${vars[0]} points*, you can apply them to your purchase for *${vars[1]} off*.`,
        cashWillApplyHere: 'Your Beauty Insider Cash will appear here.',
        applyInBasket: 'Apply in Basket',
        shopToEarnPoints: 'Shop to Earn Points',
        BICash: 'Beauty Insider Cash',
        BICashOptions: 'Beauty Insider Cash Options',
        off: 'off'
    };
    return resources[label];
};
